package one.healthium.onboarding.ui.components

import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.TextRange
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.TextFieldValue
import androidx.compose.ui.text.style.TextAlign
import one.healthium.onboarding.ui.models.WeightUnit
import one.healthium.onboarding.ui.utils.ensureKg
import one.healthium.onboarding.ui.utils.toUnitString
import one.healthium.ui.compose.components.AppTextField
import one.healthium.ui.compose.theme.AppTheme

@Composable
internal fun WeightInputTextFiled(
    modifier: Modifier = Modifier,
    weight: Float?,
    weightUnit: WeightUnit,
    onWeightChanged: (Float?) -> Unit,
) {
    var weightStr by remember {
        mutableStateOf(
            TextFieldValue(text = weight.toUnitString(weightUnit))
        )
    }
    LaunchedEffect(weight) {
        weightStr = weightStr.copy(
            text = weight.toUnitString(weightUnit)
        )
    }
    LaunchedEffect(weightUnit) {
        val newText = weight.toUnitString(weightUnit)
        weightStr = weightStr.copy(
            text = newText,
            selection = TextRange(newText.length)
        )
    }

    AppTextField(
        modifier = modifier,
        value = weightStr,
        onValueChange = { newValue ->
            weightStr = newValue
            val updatedWeight = if (newValue.text.isNotBlank()) {
                newValue.text.toIntOrNull()?.toFloat() ?: weight
            } else {
                null
            }
            onWeightChanged(updatedWeight.ensureKg(weightUnit))
        },
        textStyle = AppTheme.textStyles.textField.copy(textAlign = TextAlign.Center),
        keyboardOptions = KeyboardOptions(
            keyboardType = KeyboardType.NumberPassword,
            imeAction = ImeAction.Done,
        ),
        maxLines = 1,
        showKeyboardAutomaticallyIfEmpty = true,
    )
}